import { COLORS } from './colors';
import { makeStyles } from '@material-ui/core';
import React, { useCallback } from 'react';

interface StyleParams {
    color: string;
}

const useStyles = makeStyles({
    container: {
        backgroundColor: (params: StyleParams) => params.color,
        borderColor: (params: StyleParams) => (params.color === COLORS[0] ? '#eee' : 'transparent'),
        borderRadius: 4,
        borderStyle: 'solid',
        borderWidth: 1,
        cursor: 'pointer',
        height: 24,
        width: 24,
    },
});

export interface ColorSquareProps {
    color: string;
    onSelect: (color: string) => void;
}

export const ColorButton = (props: ColorSquareProps) => {
    const { color, onSelect } = props;

    const handleClick = useCallback(() => onSelect(color), [color, onSelect]);

    const classes = useStyles({ color });

    return <div className={classes.container} onClick={handleClick} />;
};
